// extracted by mini-css-extract-plugin
module.exports = {"load-shedding-A":"A_load-shedding-A__WnMWW"};